import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import CardHeader from '~/components/CardHeader/CardHeader';
import includes from 'lodash/includes';
import { ordinalize } from 'lodash-inflection';

import css from './PenaltySummary.scss';
import PenaltyCard from '../PenaltyCard/PenaltyCard';

const PenaltySummary = props => {
  const [loadMore, setLoadMore] = useState(false);

  // map the scorings to the associated period
  const periodType = 'period';
  const periodNumbers = [];
  const periods = {};

  props.penalties.forEach(penalty => {
    const period = penalty[periodType];

    if (!includes(periodNumbers, period)) {
      periods[period] = [];
      periodNumbers.push(period);
    }
    periods[period].push(penalty);
  });

  return (
    <div>
      <div className={css.header}>
        <h2>Penalty Summary</h2>
        {props.penalties.length > 2 ? (
          <span className={css.loadMore} onClick={() => setLoadMore(!loadMore)}>
            {loadMore ? 'Load less' : 'Load more'}
          </span>
        ) : null}
      </div>

      {!props.penalties ? <div /> : null}

      {!props.penalties.length ? <div className={css.noPenaltiesCard}>No penalties</div> : null}

      {Object.keys(periods)
        .slice(0, loadMore ? periods.length : 1)
        .map(key => (
          <div key={`period-${key}`} className={css.period}>
            <CardHeader>
              <div className={css.periodTitle}>
                {periods[key][0].segment_string || `${ordinalize(periods[key][0].segment)} segment`}
              </div>
            </CardHeader>
            {periods[key].slice(0, loadMore ? periods[key].length : 2).map(penalty => (
              <div key={`period-${key}-${penalty.api_uri}`} className={css.penaltyCard}>
                <PenaltyCard penalty={penalty} key={penalty.id} />
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

PenaltySummary.propTypes = {
  penalties: PropTypes.array.isRequired,
};

PenaltySummary.displayName = 'PenaltySummary';

export default StyledComponent(PenaltySummary, [css]);
